// extracted by mini-css-extract-plugin
export default {"button":"LoginProcessForm_button__JruG7","navigation":"LoginProcessForm_navigation__ycoeK"};